import { DateTime } from 'luxon'

import { TimeStepValueDTO } from '@/api/core/dto/snapshot/TimeStepValueDTO'
import { numberOr } from '@/utils/converters'

import { ITimeAndCityLocalizable } from '@/model/ITimeAndCityLocalizable'
import { TimeStepValue } from '@/model/TimeStepValue'

export class TimeStepValueFactory {
  static createEmpty(snapshot: ITimeAndCityLocalizable, timestamp: DateTime): TimeStepValue {
    return new TimeStepValue(snapshot, timestamp, 0, 0, 0, 0, 0)
  }

  static fromDTO(dto: TimeStepValueDTO, snapshot: ITimeAndCityLocalizable): TimeStepValue {
    return new TimeStepValue(
      snapshot,
      DateTime.fromISO(dto.timestamp, { zone: 'UTC' }),
      numberOr(dto.maxFloodLevel),
      numberOr(dto.maxIntensity),
      numberOr(dto.maxRisk),
      numberOr(dto.maxRt),
      numberOr(dto.maxTa),
    )
  }
}
